import React from 'react';
import '../../css/landingPageStylings/SignInPageStyling.css';
import { GoogleLogin } from '@react-oauth/google';
import CollapsibleSection from "../CollapsibleSection";
import animatedLogo from "../../images/animatedLogo.PNG";
import LeafLoader from "../reusableComponents/LeafLoader";
import {AtSign} from 'lucide-react';
import { useAuth } from "../../hooks/useAuth"; // Add this import
import { ReactComponent as PlantedLogoSVG } from '../../images/animatedLogo/maskedLogoSVG.svg';
import '../../css/animationStylings/landingPageAnimations/logoAnimationStyling.css';

const SignInPage = ({ onLoginSuccess, signInType, onCloseAsGuest, onClose }) => {
    const [googleLoginFailed, setGoogleLoginFailed] = React.useState(false);
    const { refresh } = useAuth(); // Get the refresh function from useAuth

    const handleLogin = async (credentialResponse) => {
        try {
            const res = await fetch('/api/verify-google-token', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token: credentialResponse.credential }),
            });

            const data = await res.json();

            if (!res.ok) throw new Error(data.error || "Login failed");

            // Refresh the useAuth hook's state to get the latest user data
            await refresh();

            // Then call the callback
            onLoginSuccess(data);
        } catch (err) {
            setGoogleLoginFailed(true);
            console.error("Login error:", err);
        }
    };

    const signInText = {
        "1": ["Join the Planted family!", "Track progress, get insights, and join the gardening community."],
        "2": ["Sign in to Save Your Gardens!", "Build garden layouts and track the health of your gardens with our cutting edge tools."],
        "3": ["Sign in to Talk to Other Gardeners!", ""]
    }

    const [heading, subtext] = signInText[signInType] || ["Welcome!", ""];

    return (
        <div className="login-wrapper">
            <div className="login-card">
                <div className="animated-logo-section">
                    <PlantedLogoSVG className="animated-logo" />
                </div>
                <h2 className="login-heading">{heading}</h2>
                <p className="login-subtext">{subtext}</p>
                <div className="login-button">
                    <GoogleLogin
                        onSuccess={handleLogin}
                        onError={() => alert('Login Failed')}
                        shape="pill"
                        text="signin_with"
                        auto_select={true}
                        width="280"
                        size="large"
                    />
                </div>

                {googleLoginFailed && (
                    <div className="google-login-failed">
                        Google login failed, please try again or sign in another way
                    </div>
                )}

                {/*<div className={`continue-with-email-button`}>*/}
                {/*    <CollapsibleSection*/}
                {/*        icon={AtSign}*/}
                {/*        title={"Sign in with email"}*/}
                {/*        headerClassName={"sign-in-header"}*/}
                {/*    >*/}
                {/*        <div className={`email-login-content`}>*/}
                {/*            <input*/}
                {/*                type="email"*/}
                {/*                className="email-input"*/}
                {/*                placeholder="Email"*/}
                {/*                aria-label="Email address"*/}
                {/*                required*/}
                {/*            />*/}
                {/*            <input*/}
                {/*                type="password"*/}
                {/*                className="password-input"*/}
                {/*                placeholder="Password"*/}
                {/*                aria-label="Password"*/}
                {/*                required*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*    </CollapsibleSection>*/}
                {/*</div>*/}

                <div className={`continue-as-guest`}>
                    <p className="continue-as-guest-text" onClick={onCloseAsGuest}>Continue as a guest</p>
                </div>
            </div>
        </div>
    );
};

export default SignInPage;